import {MissingTranslationHandler, MissingTranslationHandlerParams} from '@ngx-translate/core';
import { LoggerService } from '../services/logger/logger.service';

export class MyMissingTranslationHandler implements MissingTranslationHandler {

    constructor(private logger: LoggerService) {

    }

    handle(params: MissingTranslationHandlerParams) {
      this.logger.logWarn('missingTranslation', 'Missing params', params.key);
      return params.key;
    }
}
